module.exports = __webpack_public_path__ + "static/media/website-security-management1.93c1fe90.png";